/**
 * Tutoriel d'une page : se lance seul à la première ouverture, rend le bouton « ? » qui le
 * rejoue. À poser dans le slot `help` de `Header`. L'auto-démarrage est réservé aux espaces
 * client ; l'admin et le PSC gardent le bouton.
 */
import { spaceForType } from "../../utils/roles";
import { useAccountStorage } from "../../hooks/useAccountStorage";
import { TourStep } from "./tourEngine";
import { TourButton } from "./TourButton";
import { useTour } from "./useTour";

export const PageTour = ({
  id,
  steps,
  autoStart,
  className,
}: {
  id: string;
  steps: () => TourStep[];
  /** Force l'auto-démarrage (le dashboard le fait pour tous les espaces). */
  autoStart?: boolean;
  className?: string;
}) => {
  const { getAccountStorage } = useAccountStorage();
  const isClientSpace = spaceForType(getAccountStorage()?.type) !== "admin";

  const { start } = useTour({
    id,
    steps,
    autoStart: autoStart ?? isClientSpace,
  });

  return <TourButton onClick={start} className={className} />;
};
